export const version = 'kunde-v1.19.0-SNAPSHOT-83a5856c4254ac5d592ae31bcc8ea83aec501619';